import { render, staticRenderFns } from "./worksheet.vue?vue&type=template&id=01158df8&scoped=true&"
import script from "./worksheet.vue?vue&type=script&lang=js&"
export * from "./worksheet.vue?vue&type=script&lang=js&"
import style0 from "./worksheet.vue?vue&type=style&index=0&id=01158df8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01158df8",
  null
  
)

export default component.exports